import { useCallback, useState } from "react";
import { ItemizedReceiptEventsProperties, PRINTED_ITEMIZED_RECEIPT, MyTripsFilter } from "redmond";
import { trackEvent } from "../../../../../../api/v1/analytics/trackEvent";

interface UsePrintItemizedReceiptOptions {
  documentId: string;
  tripId: string;
  travelType: ItemizedReceiptEventsProperties["travel_type"];
  tripsFilter: MyTripsFilter;
  printWindowTitle: string;
}

export const usePrintItemizedReceipt = ({
  documentId,
  tripId,
  travelType,
  tripsFilter,
  printWindowTitle,
}: UsePrintItemizedReceiptOptions) => {
  const [printing, setPrinting] = useState(false);

  const handlePrint = useCallback(() => {
    setPrinting(true);
    trackEvent({
      eventName: PRINTED_ITEMIZED_RECEIPT,
      properties: {
        trip_id: tripId,
        travel_type: travelType,
        active_tab: tripsFilter,
      } satisfies ItemizedReceiptEventsProperties,
    });
    setTimeout(() => {
      const divContents = document.getElementById(documentId)?.innerHTML;
      const cssHeadContents = document.head?.getElementsByTagName("style");
      const cssBodyContents = document.body.getElementsByTagName("style");
      const cssBodyStyle = document.body.getAttribute("style");
      const a = window.open(" ", " ", "height=800, width=400");
      const doc = a?.document;
      if (doc) {
        doc.write("<html><head>");
        for (let i = 0; i < cssHeadContents.length; i++) {
          doc.write(`<style>${cssHeadContents.item(i)?.innerHTML || ""}</style>`);
        }
        doc.write(`</head><body style="${cssBodyStyle}" >${divContents || ""}`);
        for (let i = 0; i < cssBodyContents.length; i++) {
          doc.write(`<style>${cssBodyContents.item(i)?.innerHTML || ""}</style>`);
        }
        doc.write("</body></html>");
        if (a) a.document.title = printWindowTitle;
        setTimeout(() => {
          a?.print();
          doc.close();
          setPrinting(false);
        }, 500);
      }
    }, 10);
  }, [documentId, tripId, travelType, tripsFilter, printWindowTitle]);

  return { printing, handlePrint };
};
